import { render, staticRenderFns } from "./template2.vue?vue&type=template&id=58035919&scoped=true&"
import script from "./template2.vue?vue&type=script&lang=js&"
export * from "./template2.vue?vue&type=script&lang=js&"
import style0 from "./template2.vue?vue&type=style&index=0&id=58035919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58035919",
  null
  
)

export default component.exports